import api from "."

const storage = api.storage

class Table_storage
{
    table = null
    component = null

    constructor(table)
    {
        this.table = table
        this.component = this.table.component
    }

    name()
    {
        return storage.name(this.component, "_table")
    }

    load()
    {
        const data = storage.get(this.component, this.name(this.component), null, Object)

        return data
    }

    save()
    {
        const tbl = this.table.tbl_el

        var thead = tbl.querySelector("thead")

        var data = { height : thead.style.height, ths: this.table.ths_width }

        storage.set(this.component, this.name(this.component), JSON.stringify(data))
    }

    reset()
    {
        storage.remove(this.component, this.name(this.component))
    }
}

export default class Table_controller
{
    MIN_COL_WIDTH = 224
    component = null
    tbl_el = null
    storage = null
    clientWidth = null

    add_new_col = null
    ths_width = {}

	constructor(self, tbl_el, client_width)
	{
        if (self.service == null)
        {
            throw new Error("Component need service name")
        }

        this.component = self
        this.tbl_el = tbl_el
        this.storage = new Table_storage(this)
        this.clientWidth = client_width

        this.tbl_el.style['table-layout'] = "fixed"

        const data = this.storage.load()

        if (data && data.ths)
        {
            this.ths_width = data.ths
        }

		this._set_resizable_width()
		this._set_resizable_hight()
        this._init_sizes()
        this._init_hight()
	}

	_set_resizable_width()
	{
		var elem

        let startX
        let elemOffsetWidth

        this.add_new_col =
            (th) =>
			{
				if (!th.__vue__.$vnode.data.normalizedStyle.width)
				{	
                    var grip = document.createElement("div")
	
					grip.innerHTML = "&nbsp;"
					grip.style.top = 0
					grip.style.right = 0
					grip.style.bottom = 0
					grip.style.width = "5px"
					grip.style.position = "absolute"
					grip.style.cursor = "col-resize"
					
					grip.addEventListener("mousedown",
						event =>
						{
							elem = th
							elem.style.pointerEvents = "none"
                            elemOffsetWidth = th.offsetWidth

                            startX = event.pageX
	
							var selection = window.getSelection ? window.getSelection() : document.selection
	
							if(selection)
							{
								if(selection.removeAllRanges)
									selection.removeAllRanges()
								else if(selection.empty)
									selection.empty()
							}
						})
	
					th.appendChild(grip)
                    th.setAttribute("data-table-column-added", true)
				}
			}

		this.tbl_el.querySelectorAll("th").forEach(this.add_new_col)

		document.addEventListener("mousemove",
			event =>
			{
				if(elem)
				{
                    const diff = event.pageX - startX
					const new_elem_width = elemOffsetWidth + diff

					if (new_elem_width >= this.MIN_COL_WIDTH)
					{
                        const th_id = elem.querySelector("div").id
                        this.ths_width[th_id] = new_elem_width
                        this._init_sizes()
					}
				}
			})

		document.addEventListener("mouseup",
			() =>
			{
				if (elem)
				{
					elem.style.pointerEvents = "all"

                    const th_id = elem.querySelector("div").id
                    this.ths_width[th_id] = elem.clientWidth
                    this._save()
				}
				elem = undefined

				this.component.$emit("column_order_has_been_changed")
			})
	}

    _set_resizable_hight()
    {
        var thead = this.tbl_el.querySelector("thead")
		var height_changing = false
		var height_offset

		if(thead.querySelector(".hor_resizer") == null)
        {
            var head_grip = document.createElement("div")

            head_grip.classList.add("hor_resizer")
            head_grip.style.width = "100%"
            head_grip.style.height = "5px"
            head_grip.style.cursor = "n-resize"
            head_grip.style.position = "absolute"

            head_grip.addEventListener("mousedown",
                event =>
                {
                    height_changing = true
                    height_offset = thead.offsetHeight - event.pageY
                })

            thead.appendChild(head_grip)
        }

        document.addEventListener("mousemove",
			event =>
			{
				var changes = false

				if(height_changing)
                {
                    const new_height = height_offset + event.pageY
                    const lines = this._get_lines(new_height)

                    thead.style.height = new_height + "px"
                    thead.querySelectorAll("div .table_head_div").forEach(el => { el.style["-webkit-line-clamp"] = lines })
                    
                    changes = true
                }

                if(changes)
                    this._save()
			})
        
        document.addEventListener("mouseup",
            () =>
            {
                height_changing = false
                
                this._save()

                this.component.$emit("column_order_has_been_changed")
            })
    }

    _init_hight()
    {
        const storage_data = this.storage.load()

        var thead = this.tbl_el.querySelector("thead")

		if (storage_data != null && storage_data.height != "" && storage_data.height != null)
		{
			let lines = this._get_lines(parseInt(storage_data.height))

			if (lines <= 1) {
				lines = 1
			}

			thead.style.height = storage_data.height

			this.tbl_el.querySelectorAll("div .table_head_div").forEach(
				el =>
				{
					if((el.style["-webkit-line-clamp"] == null || el.style["-webkit-line-clamp"] == ""))
						el.style["-webkit-line-clamp"] = lines
				})
		}

    }

    _init_sizes()
    {
        var ths = this.tbl_el.querySelectorAll("th")

        let cols_count = 0
        let not_include_width = 0

        ths.forEach((th) => {
            const th_id = th.querySelector("div").id

            if (th.__vue__.$vnode.data.normalizedStyle.width)
            {
                not_include_width += parseInt(th.__vue__.$vnode.data.normalizedStyle.width)
            }
            else if (this.ths_width[th_id])
            {
                not_include_width += this.ths_width[th_id]
            }
            else
            {
                cols_count++
            }
        })

        let col_width = (this.clientWidth - not_include_width) / cols_count - 0.5

        ths.forEach(th => {
            const th_id = th.querySelector("div").id
            
            if (th.__vue__.$vnode.data.normalizedStyle.width != null)
            {
                th.style.width = th.__vue__.$vnode.data.normalizedStyle.width + "px"
            }
            else if (this.ths_width[th_id])
            {
                th.style.width = this.ths_width[th_id] + "px"
            }
            else if (col_width < this.MIN_COL_WIDTH)
            {
                th.style.width = this.MIN_COL_WIDTH + "px"
            }
            else
            {
                th.style.width = null
            }
        })
    }

	set_width()
	{
        this.tbl_el.querySelectorAll(`th:not([data-table-column-added="true"])`).forEach(
                th => { if (!th.__vue__.$vnode.data.normalizedStyle.width) { this.add_new_col(th) } }
        )

        this._init_sizes()
        this._init_hight()
	}

    _save()
    {
        this.storage.save()
    }

    resize(client_width)
    {
        this.clientWidth = client_width
        this._init_sizes()
    }

	reset()
	{
		this.storage.reset()
        this.ths_width = {}
        
		this.tbl_el.querySelectorAll("th").forEach(th => {
            if (th.__vue__.$vnode.data.normalizedStyle.width == null)
            {
                th.style.width = null
            }
            th.querySelector("div .table_head_div").style["-webkit-line-clamp"] = null
        })
        this.tbl_el.querySelector("thead").style.height = null

        this.set_width()
	}

    _get_lines(height)
	{
		return Math.round(height / 20)
	}
}
